import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * UserProtectedRoute - Protects routes that require authentication
 * 
 * IMPORTANT: This guard does NOT show a loading screen.
 * The GlobalAuthGate handles the "checking" state at the top level.
 * This guard only handles redirects for unauthenticated users.
 */
const UserProtectedRoute = ({ children }) => {
  const { user, authStatus } = useAuth();
  const location = useLocation();

  // Note: authStatus === 'checking' is handled by GlobalAuthGate
  // We only reach here when auth check is complete

  // Not authenticated - redirect to login
  if (authStatus === 'unauthenticated' || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default UserProtectedRoute;
